export default __webpack_public_path__ + "static/media/icone-youtube-redondo-branco.7c77e7c1.svg";